<template>
    <div class="area-disputa">
        <h4 class="area-disputa__titulo">Acompanhamento da Disputa</h4>
        <p class="text-md-center mb-1">Abaixo serão listados somente os itens que receberam lances.</p>

        <v-data-table :headers="showHeaders" :items="value" hide-actions
                      class="az-table-list area-disputa__tabela"
                      no-data-text="Não há envio de lances">
            <template slot="items" slot-scope="props">
                <td class="text-uppercase">
                    {{ props.item.identificacaoSequencial }}
                </td>
                <td>
                    <ver-mais v-if="props.item.tipo === 'LOTE'"
                              :tamanho="tamanho"
                              :descricao="props.item.itens[0].descricao"
                              :itens="props.item.itens"/>
                    <expansao-texto v-else
                                    :tamanho="tamanho"
                                    :texto="props.item.itens[0].descricao"/>
                </td>
                <td style="text-align: center">
                    {{ props.item.propostas }}
                </td>
                <td v-if="verificarSeDeveExibirValoresMelhorLance" style="text-align: right">
                    {{ props.item.valor | cdCurrency(prefixoValor, casasDecimais)}} {{ sufixo }}
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'AcompanhamentoTabela',
    props: {
        value: {
            default: () => {
                return []
            }
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        prefixo: {
            type: String,
            default: 'R$'
        },
        tipoCompraDireta: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            tamanho: null,
            colunas: [
                {
                    sortable: true,
                    value: 'sequencia',
                    text: 'Seq',
                    width: '40',
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    sortable: false,
                    text: 'Descrição',
                    align: 'left',
                    width: '300',
                    value: 'descricao',
                    class: 'primary--text'
                },
                {
                    align: 'center',
                    sortable: false,
                    width: '50',
                    text: 'Propostas',
                    value: 'propostas',
                    class: 'primary--text'
                },
                {
                    align: 'right',
                    sortable: false,
                    width: '100',
                    text: 'Melhor Lance',
                    value: 'valor',
                    class: 'primary--text'
                }
            ]
        }
    },
    computed: {
        ...mapState(['loki']),
        prefixoValor() {
            if (this.prefixo === '%') {
                return ''
            }
            return 'R$'
        },
        sufixo() {
            if(this.prefixo === '%') {
                return this.prefixo
            }
            return ''
        },
        verificarSeDeveExibirValoresMelhorLance() {
            return this.tipoCompraDireta === 'COM_DISPUTA'
        },
        showHeaders() {
            if (this.tipoCompraDireta === 'SEM_DISPUTA') {
                return this.colunas.filter(coluna => coluna.text !== 'Melhor Lance')
            }
            return this.colunas
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    methods: {
        pegarTamanho() {
            this.tamanho = .120 * window.innerWidth
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
}
</script>

<style scoped lang="stylus">
    .area-disputa
        padding 40px 20px
        border-top 1px solid #ebebeb

        &__titulo
            text-align center
            margin-bottom 10px

        &__tabela td:nth-child(3)
            text-align right

    @media (max-width 720px)
        .area-disputa
            padding 20px

            &__tabela
                td:nth-of-type(1):before
                    content "Sequência:"
                    text-transform capitalize

                td:nth-of-type(2):before
                    content "Descrição:"

                td:nth-of-type(3):before
                    content "Melhor Lance:"

                td:nth-of-type(3)
                    text-align left
</style>